import { createElement } from "react";
import PropTypes from 'prop-types'
import cx from "classnames";
import { GridProps } from "../lib";
import '../styles/index.scss';

// versioning attributes.
import { version as componentVersion, name as componentName, name as libname } from '../../package.json';
const libraryName = libname.split('/')[0];

const Grid = ({ id, tagName, addClasses, isViewport, forwardedRef, dataTestId, children }: GridProps) => {

  return createElement(
    `${tagName}`,
    {
      className: cx("usbbp-grid", { "usbbp-viewport": isViewport }, ...addClasses),
      "data-compn": componentName,
      "data-compv": componentVersion,
      "data-libn": libraryName,
      ref: forwardedRef,
      id: id,
      "data-test": `usbbp-grif-${dataTestId}`
    },
    children
  );
};

Grid.propTypes = {
  /**
   * Ref on parent container
   */
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object })
  ]),
  /**
   * ID on parent container
   */
  id: PropTypes.string,
  tagName: PropTypes.string,
  /**
   * Any classes you want to add to the parent container
   */
  addClasses: PropTypes.arrayOf(PropTypes.string),
  isViewport: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.elementType,
    PropTypes.array,
    PropTypes.object,
    PropTypes.node
  ]),
  dataTestId: PropTypes.string,
};
Grid.defaultProps = {
  tagName: 'article',
  addClasses: [],
  isViewport: false,
  dataTestId: '',
  children: null

};

export default Grid;
